import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const fr = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Télécharger les données</b>
        </p>
        <p>
          Pour télécharger vos données rendez-vous sur la page suivante
          <br />
          Paramètres {'>'} Options {'>'} Gestion des données {'>'} Télécharger
          les données
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Demander la suppression des données</b>
    </p>
    <br />
    <p>
      Pour demander la suppression des données, suivez les étapes ci-dessous:
    </p>
    <br />
    <p>
      1. Aller à la page{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Contactez-nous
      </UrlLink>
      <br />
      2. Sélectionnez l'option "Supprimer le compte et toutes mes données"
      <br />
      3. Remplissez le formulaire et appuyez sur "Envoyer un message" <br />
      <br />
    </p>
  </div>
);
export default fr;
